// utils/fetchers.ts
import i18next from "i18next";

export const fetcher = async <T>(url: string, token?: string): Promise<T> => {
  const res = await fetch(`${process.env.REACT_APP_API_URI}${url}`, {
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": i18next.language,
      ...(token ? { Authorization: `${token}` } : {}),
    },
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || "فشل في تحميل البيانات");
  }

  return res.json();
};
